import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { DialogFrame, DialogLink } from "component/shared/dialog-frame";
import { OutlinedButton } from "component/shared/outlined-button";
import { CONTACT_SUPPORT_URL } from "../constants";
import { styles } from "./style";

interface OwnProps {
	open: boolean;
	onSwitch: () => void;
	onCancel: () => void;
}

interface Props extends OwnProps, WithStyles<typeof styles> {}

/**
 * "Switch versions?" (VPLAT 30). An HTML site's IDX pages are hand-built with version-specific
 * embed code, so switching a live one breaks it. Staying put is the primary action; support uses
 * the same control and can click through knowingly.
 */
const Component: React.FC<Props> = ({ classes = {}, open, onSwitch, onCancel }) => (
	<DialogFrame
		open={open}
		onClose={onCancel}
		title="Switch versions?"
		titleId="switch-version-title"
		titleIcon={<Icons.AlertTriangle size={24} className={classes.warningIcon} aria-hidden="true" />}
		top={130}
		aria-describedby="switch-version-body"
		actions={
			<>
				<OutlinedButton onClick={onSwitch}>
					Switch Anyway
				</OutlinedButton>
				<Mui.Button variant="contained" color="primary" onClick={onCancel} autoFocus>
					Cancel
				</Mui.Button>
			</>
		}
	>
		<div id="switch-version-body" className={classes.body}>
			<Mui.Typography className={classes.text}>Switching versions may break your site.</Mui.Typography>
			<Mui.Typography className={classes.text}>
				If you'd like to make this change,{" "}
				<DialogLink href={CONTACT_SUPPORT_URL} target="_blank" rel="noopener noreferrer" className={classes.link}>
					contact support
					<Icons.ExternalLink size={16} aria-hidden="true" />
				</DialogLink>
			</Mui.Typography>
		</div>
	</DialogFrame>
);

export const SwitchVersionDialog = withStyles(Component, styles);
